const pathname: string = window.location.href;
export const { searchParams } = new URL(pathname);

function parseStringToNumber(value: string) {
  /* should be an integer */
  return Number(value.replace(/[^\d]|^0+/g, ''))
}

export default parseStringToNumber;
